/* eslint-disable camelcase */
export const submitForm = (values, actions, traplogStore, propertiesStore) => {
  const { traps: trapOptions, setup_date, charged_date, trap_lure } = values;
  const trapsUpdated = trapOptions.map((trapOption) => {
    const trap = traplogStore.traps.find(
      (trap) => trap.id === trapOption.value
    );
    return {
      id: trap.id,
      trapping_zone_id: trap.trapping_zone_id,
      code: trap.code,
      name: trap.name,
      location_description: trap.location_description,
      lat: trap.location?.coordinates[1],
      lon: trap.location?.coordinates[0],
      trap_lure_id: trap_lure?.value,
      comments: trap.comments,
      setup_at: setup_date,
      charged_at: charged_date
    };
  });
  const url = `${process.env.REACT_APP_TRAPLOG_API_URL}api/traps/batch`;
  fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${traplogStore.bearerToken}`,
      SeasonalDatabase: traplogStore.selectedDatabase
    },
    body: JSON.stringify(trapsUpdated)
  })
    .then((res) => {
      if (res.ok) return res.json();
      else if (res.status === 401) traplogStore.refreshBearerToken();
      else throw Error(res.statusText);
    })
    .then(() => {
      traplogStore.loadTrappingZones(
        traplogStore.bearerToken,
        traplogStore.refreshBearerToken,
        traplogStore.selectedDatabase,
        propertiesStore.selectedPropertyId
      );
    })
    .catch((err) => {
      if (process.env.NODE_ENV === 'development') console.error(err);
    })
    .finally(() => {
      actions.setSubmitting(false);
    });
};

export const noUpdates = ({ setup_date, charged_date, trap_lure }) => {
  if (!setup_date && !charged_date && !trap_lure) return true;
  return false;
};
